export enum WSMessage {
  MESSAGE_ADD = 'msgAdd',
  MESSAGE_ADD_OFFLINE = 'msgAddOffline',
  MESSAGE_ADD_PREVIEW = 'msgAddPreview',
  MESSAGE_EDIT = 'msgChange',
  MESSAGE_REMOVE = 'msgRemove',
  CHAT_USER_ENTER = 'chatUserEnter',
  CHAT_USER_EXIT = 'chatUserExit',
  TOTAL_ONLINE = 'totalOnline',
  BLACK_HOLE = 'blackHole',
}

export enum UPLOAD_CRITERIAS {
  MAX_W = 2300,
  MAX_H = 2300,
  MAX_IMG_BYTE = 23068672, // 18Mb
  MAX_DOC_BYTE = 104857600, // 100Mb
  MAX_IMG_THUMB_BYTE = 1048576, // 1000kb
}

export enum DefaultValues {
  SCROLL_THRESHOLD = 400,
  NOTICE_COLLAPSE_THRESHOLD = 30,
}

export const CHUNK_UPLOAD_TRIGGER_SIZE = 1_500_000 // 1.5mb

export enum BlackHoleMethods {
  USER_WRITING = 'userWriting',
}